import reportTiming from '../comm/utils/reportTiming';

export default {
  mounted() {
    if (typeof this.DOREPORT === 'undefined') {
      console.log('mounted reporting', document.title);
      this.doReport();
    }
  },
  methods: {
    doReport() {
      let pageType = 1; // 用户端
      if (this.$route.meta.authType === 'expert') {
        pageType = 2; // 专家端
      }
      reportTiming({ pageValue: document.title, pageType });
    }
  },
  watch: {
    DOREPORT: {
      handler(nextValue, oldValue) {
        if (nextValue && !oldValue) {
          console.log('watch reporting');
          this.doReport();
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/report.js